import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import './FeedItemContainer.pcss';

interface IFeedItemContainerProps {
	extraClassName?:string;
	completed:boolean;
	children:any;
}

@observer
export class FeedItemContainer extends React.Component<IFeedItemContainerProps> {
	render(){
		return(
			<div className={`feedItemContainer post ${this.props.extraClassName}${this.props.completed?' completed':''}`}>
				<table>
					<tbody>
						<tr>
							<td className="icon">{this.props.children[0]}</td>
							<td className="mid">{this.props.children[1]}</td>
							<td className="right">
								{this.props.children[2]}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}
}

